import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { UpdateEventDetails } from "../../../../revampCRUD/eventDetails.crud";
import { diffAndCommon } from "../../../../services/util";
import { getEventDetails } from "../../../../revampCRUD/app.crud";
import customToast from "../../../../components/common/basic/Toast";
import FormButtons from "../../../../revampComponents/Molecule/Buttons/FormButtons";
import { ValidatePostRegistration } from "./Validation";
import RichTextEditor from "../../../../revampComponents/TipTapEditorNew/components/RichTextEditor";
import RTE from "../../../../revampComponents/TipTapEditor/RTE";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import { sanitizeString } from "../../../../reusable/common";

const PostRegistration = ({
	eventDetails,
	className,
	whiteLabel,
	setPostRegModal,
	getEventDetailsCallBackFunc
}) => {
	const [edit, setEdit] = useState(false);
	const [loading, setLoading] = useState(false);
	const [eventDetailsFromApi, setEventDetailsFromApi] = useState(null);
	const [initialValue, setInitialValue] = useState(null)

	const updateContent = async (formName, contentUpdate, formik) => {
		const cleanContent = sanitizeString(contentUpdate);
		formik.setFieldValue(formName, cleanContent);
	};

	const validate = async values => {
		let errors = {};
		errors = await ValidatePostRegistration(values);
		return errors;
	};

	const formik = useFormik({
		initialValues: initialValue,
		enableReinitialize: true,
		validateOnBlur: true,
		validateOnChange: true,
		validate: validate,

		onSubmit: values => {
			if (edit) return;

			setEdit(true);
			const event_updates = diffAndCommon("diff", [values, initialValue], []);

			UpdateEventDetails(event_updates, eventDetails.event_id)
				.then(({ data }) => {
					if (data == "OK") {
						if (whiteLabel) {
							setPostRegModal(false);
							getEventDetailsCallBackFunc();
						}
						setEdit(false);
						getEventDetails(eventDetails.event_id);
						customToast.success("Saved successfully!");
						formik.resetForm({ values });

					} else {
						setEdit(false);
						customToast.error("Something went wrong");
					}
				})
				.catch(err => {
					const error = err?.response?.data?.error || "Something went wrong";
					setEdit(false);
					customToast.error(error);
				});
		}
	});

	const cancelBtnHandler = () => {
		if (whiteLabel) {
			setPostRegModal(false);
		}
		formik.resetForm();
	};
	const getEventDetailsFunction = async eventId => {
		setLoading(true);
		const Data = await getEventDetails(eventId);
		if (Data?.status == 200) {
			setEventDetailsFromApi(Data?.data);
			setInitialValue({
				reg_success_title: Data?.data?.reg_success_title,
				reg_success_msg: Data?.data?.reg_success_msg,
				approval_success_title: Data?.data?.approval_success_title,
				approval_success_msg: Data?.data?.approval_success_msg,
				waitlist_success_title: Data?.data?.waitlist_success_title,
				waitlist_success_msg: Data?.data?.waitlist_success_msg
			});
			setLoading(false);
		}
	};
	useEffect(() => {
		getEventDetailsFunction(eventDetails?.event_id);
	}, []);
	return (
		<>
			{(loading || !initialValue) ? (
				<LoadingSpinner />
			) :
				<div className={`row ${className ? className : ""}`}>
					<div className="border-line w-100">
						<div className="col-md-12">
							<label className="label">
								Post Registration Success Title
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the title you want to display to registered participants post their
								successful registration.
							</p>
							<input
								type="test"
								className="input"
								id="reg_success_title"
								name="reg_success_title"
								onBlur={formik.handleBlur}
								value={formik.values.reg_success_title}
								onChange={formik.handleChange}
							/>
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.reg_success_title &&
										formik.touched.reg_success_title && (
											<p>{formik.errors.reg_success_title}</p>
										)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 500</p>
							</div>
						</div>
						<div className="col-md-12 mt-3">
							<label className="label">
								Post Registration Success Description
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the message you want to display to participants post successful
								registration.
							</p>
							<RichTextEditor
								content={sanitizeString(formik.values.reg_success_msg)}
								onChangeContent={html => updateContent("reg_success_msg", html, formik)}
								showTextFormatters
								showTextHighlighters
								showHistory
								showTextAligners
								showLists
								showBlockQuote
								showHr
								showLink
							/>

							{/* <RTE
						onChange={html => updateContent("reg_success_msg", html, formik)}
						value={formik.values.reg_success_msg}
						minimalistic={true}
						uploadDocPrompt={false}
						className="editor-class"
						editorClassName="editor-class-content"
						showHighlighters={true}
						showTextAlignment={true}
						showLists={true}
						showLinks={true}
						minHeight={100}
					/> */}
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.reg_success_msg && formik.touched.reg_success_msg && (
										<p>{formik.errors.reg_success_msg}</p>
									)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 5000</p>
							</div>
							<p className="sub-text">
								<b>Note:</b>
								{
									" ${sender_email_id} is the email id through which the registration confirmation emails are sent."
								}
							</p>
						</div>
					</div>
					<div className="border-line w-100">
						<div className="col-md-12 mt-3">
							<label className="label">
								Post Approval Registration Title
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the title you want to display to interested participants post their
								approval registration request submission.
							</p>
							<input
								type="test"
								className="input"
								id="approval_success_title"
								name="approval_success_title"
								onBlur={formik.handleBlur}
								value={formik.values.approval_success_title}
								onChange={formik.handleChange}
							/>
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.approval_success_title &&
										formik.touched.approval_success_title && (
											<p>{formik.errors.approval_success_title}</p>
										)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 500</p>
							</div>
						</div>
						<div className="col-md-12 mt-3">
							<label className="label">
								Post Approval Registration Description
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the title you want to display to interested participants post
								submission of approval requests.
							</p>

							<RichTextEditor
								content={sanitizeString(formik.values.approval_success_msg)}
								onChangeContent={html => updateContent("approval_success_msg", html, formik)}
								showTextFormatters
								showTextHighlighters
								showHistory
								showTextAligners
								showLists
								showBlockQuote
								showHr
								showLink
							/>

							{/* <RTE
						onChange={html => updateContent("approval_success_msg", html, formik)}
						value={formik.values.approval_success_msg}
						minimalistic={true}
						uploadDocPrompt={false}
						className="editor-class"
						editorClassName="editor-class-content"
						showHighlighters={true}
						showTextAlignment={true}
						showLists={true}
						showLinks={true}
					/> */}
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.approval_success_msg &&
										formik.touched.approval_success_msg && (
											<p>{formik.errors.approval_success_msg}</p>
										)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 2000</p>
							</div>
							<p className="sub-text">
								<b>Note:</b>{" "}
								{
									"${sender_email_id} is the email id through which the registration confirmation emails are sent."
								}
							</p>
						</div>
					</div>
					<div className="border-line w-100">
						<div className="col-md-12 mt-3">
							<label className="label">
								Post waitlist Registration Title
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the title you want to display to interested participants post their
								waitlist request submission.
							</p>
							<input
								type="test"
								className="input"
								id="waitlist_success_title"
								name="waitlist_success_title"
								onBlur={formik.handleBlur}
								value={formik.values.waitlist_success_title}
								onChange={formik.handleChange}
							/>
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.waitlist_success_title &&
										formik.touched.waitlist_success_title && (
											<p>{formik.errors.waitlist_success_title}</p>
										)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 500</p>
							</div>
						</div>
						<div className="col-md-12 mt-3">
							<label className="label">
								Post waitlist Registration Description
								<span className="text-danger"> *</span>
							</label>
							<p className="sub-text">
								Provide the title you want to display to interested participants post
								submission of waitlist requests.
							</p>
							<RichTextEditor
								content={sanitizeString(formik.values.waitlist_success_msg)}
								onChangeContent={html =>
									updateContent("waitlist_success_msg", html, formik)
								}
								showTextFormatters
								showTextHighlighters
								showHistory
								showTextAligners
								showLists
								showBlockQuote
								showHr
								showLink
							/>

							{/* <RTE
						onChange={html => updateContent("waitlist_success_msg", html, formik)}
						value={formik.values.waitlist_success_msg}
						minimalistic={true}
						uploadDocPrompt={false}
						className="editor-class"
						editorClassName="editor-class-content"
						showHighlighters={true}
						showTextAlignment={true}
						showLists={true}
						showLinks={true}
					/> */}
							<div className="d-flex justify-content-between">
								<p className="text-danger pt-1 mb-0">
									{formik.errors.waitlist_success_msg &&
										formik.touched.waitlist_success_msg && (
											<p>{formik.errors.waitlist_success_msg}</p>
										)}
								</p>
								<p className="maxCharForInput">Maximum Characters: 2000</p>
							</div>
							<p className="sub-text">
								<b>Note:</b>{" "}
								{
									"${sender_email_id} is the email id through which the registration confirmation emails are sent."
								}
							</p>
						</div>
					</div>
					<div className="col-md-12">
						<div className=" d-flex justify-content-end">
							<FormButtons
								// onCancel={() => formik.resetForm()}
								onCancel={cancelBtnHandler}
								onSave={formik.handleSubmit}
								cancelBtnContent={`Cancel`}
								isLoading={edit}
								saveBtnDisabled={edit || !formik.dirty}
							/>
						</div>
					</div>
					<style jsx>{`
				.sub-text {
					font-family: Hind;
					font-size: 14px;
					font-weight: 400;
					line-height: 22.41px;
					color: #6c757d;
				}
				.border-line {
					border: 1px solid #c3cddf99;
					padding: 10px;
					margin-bottom: 10px;
				}
			`}</style>
				</div>
			}
		</>
	);
};

export default PostRegistration;
